import styles from "./NoResult.module.scss";

export default function NoResult() {
	return (
		<div className={styles.noResult}>
			<h4>Sajnos nem találtunk ilyen nevű céget</h4>
			<p>Próbálja meg pontosan megadni cége nevét</p>
		</div>
	);
}
